// PLUGINS IMPORTS //
import React, { memo } from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import Mockup1Img from "Assets/Images/illustrations/mockups/mockup1.svg"
import Mockup2Img from "Assets/Images/illustrations/mockups/mockup2.svg"
import Mockup3Img from "Assets/Images/illustrations/mockups/mockup3.svg"
import Mockup4Img from "Assets/Images/illustrations/mockups/mockup4.svg"
import Mockup5Img from "Assets/Images/illustrations/mockups/mockup5.svg"

/////////////////////////////////////////////////////////////////////////////

interface PropsType {}

const ImageSection: React.FC<PropsType> = () => {
  return (
    <Wrapper>
      <div className={"mockup1"} />
      <div className={"mockup2"} />
      <div className={"mockup3"} />
      <div className={"mockup4"} />
      <div className={"mockup5"} />
    </Wrapper>
  )
}

/////////////////////////////////////////////////////////////////////////////

const Wrapper = styled.div`
  position: relative;
  perspective: 5000;

  @media (max-width: 1512px) {
    transform: scale(0.9);
    transform-origin: top left;
  }

  @media (max-width: 1429px) {
    transform: scale(0.8);
    transform-origin: top left;
  }

  @media (max-width: 1350px) {
    transform: scale(0.7);
    transform-origin: top left;
  }

  @media (max-width: 768px) {
    transform: scale(0.4);
    transform-origin: top left;
  }
  @media (max-width: 450px) {
    transform: scale(0.32);
    margin-top: 70px;
    margin-left: 56%;
  }

  div {
    transform: rotateY(-20deg) rotateX(20deg);
    perspective-origin: bottom left;
  }

  * {
    transition: 1s cubic-bezier(0.075, 0.82, 0.165, 1);
  }

  :hover div {
    transform: rotateY(0deg) rotateX(0deg);
    &.mockup1 {
      transform: translate(-30px, -30px);
    }
    &.mockup2 {
      transform: translate(0px, -30px);
    }
    &.mockup4 {
      transform: translate(-120px, 30px);
    }
    &.mockup5 {
      transform: translate(-90px, 30px);
    }
    :hover {
      filter: brightness(150%) saturate(120%);
    }
  }

  .mockup1 {
    position: absolute;
    width: 183px;
    height: 120px;
    right: 617px;
    top: 0px;

    background: url(${Mockup1Img}),
      radial-gradient(
        218.51% 281.09% at 100% 100%,
        rgba(253, 63, 51, 0.6) 0%,
        rgba(76, 0, 200, 0.6) 45.83%,
        rgba(76, 0, 200, 0.6) 100%
      );
    border: 0.273134px solid rgba(255, 255, 255, 0.3);
    box-sizing: border-box;
    box-shadow: 0px 16.3881px 32.7761px rgba(99, 30, 187, 0.5);
    backdrop-filter: blur(21.8507px);

    border-radius: 16.3881px;
  }

  .mockup2 {
    position: absolute;
    width: 183px;
    height: 120px;
    right: 403px;
    top: 0px;

    background: url(${Mockup2Img}),
      linear-gradient(
        198.85deg,
        #4316db 12.72%,
        #9076e7 54.49%,
        #a2eeff 100.01%
      );
    border: 0.27304px solid rgba(255, 255, 255, 0.5);
    box-shadow: 0px 8.19119px 16.3824px rgba(0, 0, 0, 0.1),
      0px 16.3824px 32.7648px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(21.8432px);

    border-radius: 16.3824px;
  }

  .mockup3 {
    position: absolute;
    width: 701px;
    height: 428px;
    right: 62px;
    top: 60px;

    background: url(${Mockup3Img}), rgba(23, 12, 61, 0.5);
    border: 0.342305px solid rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(27.3844px);

    border-radius: 6.8461px;
  }

  .mockup4 {
    position: absolute;
    width: 399px;
    height: 274px;
    right: 207px;
    top: 262px;

    background: url(${Mockup4Img}), rgba(39, 20, 62, 0.3);
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    backdrop-filter: blur(27.3844px);

    border-radius: 14px;
  }

  .mockup5 {
    position: absolute;
    width: 412px;
    height: 274px;
    right: -228px;
    top: 262px;

    background: url(${Mockup5Img}), rgba(39, 20, 62, 0.2);
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;
    backdrop-filter: blur(27.3844px);

    border-radius: 14px;
  }
`

export default memo(ImageSection, memoComparison)
